import { Color, ColorRepresentation } from 'three';

declare module '../imports'
{
    interface Color
    {
        set value(v: ColorRepresentation);
    }
}

// eslint-disable-next-line accessor-pairs
Object.defineProperty(Color.prototype, 'value', {
    set(this: Color, v: ColorRepresentation)
    {
        this.set(v);
    }
});

export { Color };
